import { getTransactionsStatsApi, getTransactionsSummaryApi, getTransactionsApi, } from '../api/transactions';
const transactionsActions = {
    getTransactionsStats: async (projectId) => {
        try {
            const { data: res } = await getTransactionsStatsApi(projectId);
            return res ?? null;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
    getTransactionsSummary: async ({ projectId, params }, { setState }) => {
        try {
            const { data: res } = await getTransactionsSummaryApi(projectId, params);
            setState((state) => {
                state.transactionsTable = res.transactions ?? [];
            });
            return res ?? null;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
    getTransactions: async ({ projectId, params }, { setState }) => {
        try {
            const { data: res } = await getTransactionsApi(projectId, params);
            setState((state) => {
                state.transactionsTable = [...state.transactionsTable, ...res.transactions];
            });
            return res ?? null;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
};
export default transactionsActions;
